import NoMassMessagesIcon from '@/assets/images/empty-mass-messages.svg'

import { CreateMessageButton } from '../create-message-button'

export const MassMessagesEmptyData = () => {
  return (
    <div className="absolute inset-0 left-[300px] top-[72px] flex flex-1 flex-col items-center justify-center bg-background max-lg:left-0">
      <NoMassMessagesIcon />

      <div className="mb-5 text-center">
        <h1 className="mt-3 text-2xl font-semibold leading-none text-title">
          No Online Mass Messages
        </h1>

        <div className="relative">
          <h2 className="mt-1.5 max-w-lg text-center text-base text-text-sub">
            Configure your Online Mass Message to be sent out to users who are
            online during the selected time frame.
          </h2>
        </div>
      </div>

      <CreateMessageButton containerClassName="mt-4" />
    </div>
  )
}
